import React from 'react';
import './LegalPage.css';

const PrivacyPolicy = () => (
  <div className="legal-page">
    <div className="legal-hero">
      <div className="container">
        <h1>Privacy Policy</h1>
        <p>Last updated: January 1, 2025</p>
      </div>
    </div>
    <div className="legal-body container">
      <section>
        <h2>1. Introduction</h2>
        <p>Smart Property Solutions ("we", "our", or "us"), operating from H-32, Office No. 304, Sector 63, Noida, is committed to protecting your personal information and your right to privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website or engage with our services.</p>
        <p>By using our website or services, you consent to the data practices described in this policy. If you do not agree, please discontinue use of our services.</p>
      </section>

      <section>
        <h2>2. Information We Collect</h2>
        <h3>2.1 Personal Information You Provide</h3>
        <p>We collect information that you voluntarily provide when you:</p>
        <ul>
          <li>Submit an enquiry form or contact us directly</li>
          <li>Register for property site visits or events</li>
          <li>Subscribe to our newsletters or property alerts</li>
          <li>Communicate with us via phone, email, or WhatsApp</li>
        </ul>
        <p>This may include your name, email address, phone number, location preferences, and budget range.</p>

        <h3>2.2 Automatically Collected Information</h3>
        <p>When you visit our website, we may automatically collect certain technical data including your IP address, browser type, pages visited, time spent on pages, and referring URL. This data is used solely to improve website performance and user experience.</p>
      </section>

      <section>
        <h2>3. How We Use Your Information</h2>
        <p>We use the information we collect for the following purposes:</p>
        <ul>
          <li>To respond to your enquiries and provide property-related information</li>
          <li>To schedule site visits, meetings, and follow-ups</li>
          <li>To send property listings, offers, and market updates relevant to your preferences</li>
          <li>To process transactions and manage our business relationship with you</li>
          <li>To comply with applicable laws and regulatory requirements under RERA</li>
          <li>To improve our website, services, and customer experience</li>
          <li>To send periodic marketing communications (with your consent)</li>
        </ul>
      </section>

      <section>
        <h2>4. Sharing of Your Information</h2>
        <p>We do not sell, trade, or rent your personal information to third parties. We may share your information only in the following circumstances:</p>
        <ul>
          <li><strong>With Developers/Builders:</strong> When you express interest in a specific project, your contact details may be shared with the respective developer to facilitate the transaction.</li>
          <li><strong>Service Providers:</strong> We may share data with trusted service providers (e.g., CRM platforms, email services) who assist us in operations, bound by strict confidentiality obligations.</li>
          <li><strong>Legal Compliance:</strong> We may disclose information when required by law, court order, or governmental authority.</li>
          <li><strong>Business Transfers:</strong> In the event of a merger or acquisition, your information may be transferred as part of the business assets.</li>
        </ul>
      </section>

      <section>
        <h2>5. Data Security</h2>
        <p>We implement industry-standard security measures including SSL encryption, secure servers, and restricted access controls to protect your personal information. However, no method of transmission over the internet is 100% secure, and we cannot guarantee absolute security.</p>
        <p>We retain your personal data only as long as necessary for the purposes outlined in this policy, or as required by applicable law.</p>
      </section>

      <section>
        <h2>6. Cookies</h2>
        <p>Our website may use cookies to enhance your browsing experience. Cookies are small text files stored on your device. You may choose to disable cookies through your browser settings, though this may affect certain website functionality. We use cookies for:</p>
        <ul>
          <li>Remembering your preferences and session information</li>
          <li>Analysing website traffic and usage patterns</li>
          <li>Delivering relevant content based on your interests</li>
        </ul>
      </section>

      <section>
        <h2>7. Third-Party Links</h2>
        <p>Our website may contain links to third-party websites. We are not responsible for the privacy practices or content of such external sites. We encourage you to review the privacy policies of any third-party sites you visit.</p>
      </section>

      <section>
        <h2>8. Your Rights</h2>
        <p>You have the right to:</p>
        <ul>
          <li>Access the personal information we hold about you</li>
          <li>Request correction of inaccurate or incomplete data</li>
          <li>Request deletion of your personal data (subject to legal obligations)</li>
          <li>Withdraw consent for marketing communications at any time</li>
          <li>Lodge a complaint with relevant data protection authorities</li>
        </ul>
        <p>To exercise any of these rights, please contact us at <a href="mailto:info@smartpropertysolutions.in">info@smartpropertysolutions.in</a>.</p>
      </section>

      <section>
        <h2>9. RERA Compliance</h2>
        <p>Smart Property Solutions is committed to full compliance with the Real Estate (Regulation and Development) Act, 2016 (RERA) and all applicable state-level RERA regulations. Any information collected during the course of our real estate advisory services is handled in accordance with RERA guidelines.</p>
      </section>

      <section>
        <h2>10. Changes to This Policy</h2>
        <p>We reserve the right to update this Privacy Policy at any time. Changes will be posted on this page with an updated revision date. We encourage you to review this policy periodically. Your continued use of our services after any changes constitutes your acceptance of the revised policy.</p>
      </section>

      <section>
        <h2>11. Contact Us</h2>
        <p>If you have any questions, concerns, or requests regarding this Privacy Policy, please contact us:</p>
        <div className="legal-contact">
          <p><strong>Smart Property Solutions</strong></p>
          <p>H-32, Office No. 304, Sector 63, Noida</p>
          <p>Phone: <a href="tel:+919891156565">+91 98911 56565</a></p>
          <p>Email: <a href="mailto:info@smartpropertysolutions.in">info@smartpropertysolutions.in</a></p>
        </div>
      </section>
    </div>
  </div>
);

export default PrivacyPolicy;
